(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b100-b2b-application"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-b2b-form')) {
    let turnstilePromise;
    const loadTurnstile = () => {
      if (window.turnstile) return Promise.resolve(window.turnstile);
      if (!turnstilePromise) {
        turnstilePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('verification'));
          script.onerror = () => { script.remove(); reject(new Error('verification')); };
          document.head.appendChild(script);
        }).catch(error => { turnstilePromise = undefined; throw error; });
      }
      return turnstilePromise;
    };
    customElements.define('b100-b2b-form', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.approved === 'true' && !window.Shopify?.designMode) {
          window.location.replace(this.dataset.accountUrl);
          return;
        }
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.abort = new AbortController();
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.button = this.form.querySelector('[type="submit"]');
        this.error = this.querySelector('[data-error]');
        this.form.addEventListener('input', event => { event.target.removeAttribute('aria-invalid'); event.target.setCustomValidity?.(''); }, { signal: this.abort.signal });
        const success = this.querySelector('[data-email-success]');
        if (success) { success.focus(); return; }
        if (this.dataset.mode !== 'customer') return;
        if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
          this.form.hidden = true;
          const confirmation = this.querySelector('[data-success]');
          confirmation.hidden = false; confirmation.focus();
          return;
        }
        this.form.addEventListener('submit', event => this.submit(event), { signal: this.abort.signal });
        let endpoint;
        try { endpoint = new URL(this.dataset.endpoint); } catch { this.showError('unavailable'); return; }
        if (endpoint.protocol !== 'https:' || !this.dataset.sitekey) { this.showError('unavailable'); return; }
        this.endpoint = endpoint.href;
        this.prepareChallenge();
      }
      disconnectedCallback() {
        this.abort?.abort();
        if (this.widget !== undefined) window.turnstile?.remove(this.widget);
        this.widget = undefined;
      }
      showError(code, fields = []) {
        this.error.querySelector('[data-error-text]').textContent = this.messages[code] || this.messages.unavailable;
        this.error.hidden = false;
        for (const name of fields) {
          const field = [...this.form.querySelectorAll('[data-field]')].find(el => el.dataset.field === name);
          field?.setAttribute('aria-invalid', 'true');
        }
      }
      async prepareChallenge() {
        const signal = this.abort.signal;
        try {
          const turnstile = await loadTurnstile();
          if (!this.isConnected || signal.aborted) return;
          this.widget = turnstile.render(this.querySelector('[data-challenge]'), {
            sitekey: this.dataset.sitekey, action: 'b2b_application', theme: 'light', size: this.clientWidth >= 300 ? 'flexible' : 'compact',
            callback: token => { this.token = token; if (!this.pending) this.button.disabled = false; },
            'expired-callback': () => { this.token = ''; this.button.disabled = true; },
            'error-callback': () => { this.token = ''; this.button.disabled = true; this.showError('verification'); },
          });
        } catch { if (!signal.aborted) this.showError('verification'); }
      }
      async submit(event) {
        event.preventDefault();
        if (this.pending || !this.endpoint) return;
        if (!this.token) { this.showError('verification'); this.error.focus(); return; }
        if (!this.form.reportValidity()) return;
        const payload = {};
        this.form.querySelectorAll('[data-field]').forEach(field => { payload[field.dataset.field] = field.type === 'checkbox' ? field.checked : field.value; });
        const phone = payload.phone.trim().replace(/[\s().-]/g, '').replace(/^00/, '+');
        if (!/^(?:[26]\d{9}|\+[1-9]\d{7,14})$/.test(phone)) {
          const field = this.form.querySelector('[data-field="phone"]');
          field.setCustomValidity(this.messages.phone); field.reportValidity(); return;
        }
        payload.token = this.token;
        this.pending = true; this.button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.error.hidden = true;
        this.button.querySelector('[data-submit-label]').textContent = this.messages.sending;
        const controller = new AbortController();
        const cancel = () => controller.abort();
        this.abort.signal.addEventListener('abort', cancel, { once: true });
        const timeout = setTimeout(cancel, 35000);
        try {
          const response = await fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', body: JSON.stringify(payload), signal: controller.signal });
          const result = await response.json();
          if (!response.ok || result.ok !== true) {
            this.showError(result.code, Array.isArray(result.fields) ? result.fields : []);
            this.error.focus(); return;
          }
          this.form.hidden = true;
          const success = this.querySelector('[data-success]');
          success.hidden = false; success.focus();
          window.location.assign(this.dataset.successUrl);
        } catch { if (this.isConnected) { this.showError('unavailable'); this.error.focus(); } }
        finally {
          clearTimeout(timeout); this.abort.signal.removeEventListener('abort', cancel);
          this.pending = false; this.token = ''; this.form.removeAttribute('aria-busy');
          this.button.querySelector('[data-submit-label]').textContent = this.messages.submit;
          if (this.isConnected && !this.form.hidden && this.widget !== undefined) window.turnstile?.reset(this.widget);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b100-campaigns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-campaigns')) {
    customElements.define('b100-campaigns', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = [...this.querySelectorAll('[data-campaign-tab]')];
        this.panels = [...this.querySelectorAll('[data-campaign-panel]')];
        if (!this.tabs.length) return;
        this.querySelector('[data-campaign-list] > div').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', event => { event.preventDefault(); this.select(index, true); }, { signal });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault(); this.select(next, true); this.tabs[next].focus();
          }, { signal });
        });
        this.querySelectorAll('.b100-campaigns__frame').forEach(frame => {
          frame.addEventListener('pointerdown', event => {
            this.touch = event.pointerType === 'touch' && !event.target.closest('a, button') ? { x: event.clientX, y: event.clientY } : null;
          }, { signal, passive: true });
          frame.addEventListener('pointerup', event => {
            if (!this.touch) return;
            const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y;
            this.touch = null;
            if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select((this.index + (dx < 0 ? 1 : this.tabs.length - 1)) % this.tabs.length, true);
          }, { signal, passive: true });
          frame.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
        });
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, { signal });
        this.select(0);
      }
      select(index, animate = false) {
        this.animations?.forEach(animation => animation.cancel());
        this.index = index;
        this.tabs.forEach((tab, current) => {
          tab.setAttribute('aria-selected', String(current === index));
          tab.tabIndex = current === index ? 0 : -1;
          this.panels[current].hidden = current !== index;
        });
        if (animate && this.dataset.motion === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.animations = [...this.panels[index].querySelectorAll('.b100-campaigns__photo picture, .b100-campaigns__copy')].map(element => element.animate([{ opacity: .3, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 320, easing: 'ease-out' }));
        }
        window.ScrollTrigger?.refresh();
      }
      disconnectedCallback() { this.controller?.abort(); this.animations?.forEach(animation => animation.cancel()); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b100-department-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-departments')) {
    customElements.define('b100-departments', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.animation?.cancel();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = [...this.querySelectorAll('[data-department-choice]')];
        this.panels = [...this.querySelectorAll('[data-department-panel]')];
        if (this.tabs.length < 2) return;
        this.querySelector('[data-department-list]').setAttribute('role', 'tablist');
        this.querySelector('[data-department-list]').setAttribute('aria-orientation', 'horizontal');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => { event.preventDefault(); this.select(index, true); }, { signal });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault(); this.select(next, true); this.tabs[next].focus({ preventScroll: true });
          }, { signal });
        });
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, { signal });
        const hashIndex = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
        this.select(hashIndex >= 0 ? hashIndex : 0);
      }
      select(index, interactive = false) {
        if (!this.panels[index]) return;
        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
        });
        if (interactive) {
          const list = this.querySelector('[data-department-list]');
          const tabRect = this.tabs[index].getBoundingClientRect();
          const listRect = list.getBoundingClientRect();
          if (tabRect.left < listRect.left) list.scrollLeft += tabRect.left - listRect.left - 5;
          else if (tabRect.right > listRect.right) list.scrollLeft += tabRect.right - listRect.right + 5;
        }
        this.animation?.cancel();
        if (interactive && !matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
          this.animation = this.panels[index].querySelector('.b100-departments__image-layer').animate([{ opacity: .65 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
        }
        window.ScrollTrigger?.refresh();
      }
      disconnectedCallback() { this.controller?.abort(); this.animation?.cancel(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b100-product-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-product-tabs')) {
    customElements.define('b100-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        if (this.tabs.length < 2) return;
        this.querySelector('[data-tab-list]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', (event) => { event.preventDefault(); this.select(index); }, { signal });
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }, { signal });
        });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, { signal });
        this.select(0);
      }
      select(index) {
        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b100-room-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-room-discovery')) {
    customElements.define('b100-room-discovery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.buttons = [...this.querySelectorAll('[data-room-mode]')];
        this.photos = [...this.querySelectorAll('[data-room-scene]')];
        this.markers = this.querySelector('[data-room-markers]');
        this.querySelector('[data-room-controls]')?.removeAttribute('hidden');
        this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.roomMode), { signal }));
        this.querySelectorAll('[data-room-product]').forEach(marker => {
          const card = this.querySelector(`[data-room-card="${marker.dataset.roomProduct}"]`);
          const highlight = () => card?.setAttribute('data-highlighted', '');
          const clear = () => card?.removeAttribute('data-highlighted');
          marker.addEventListener('pointerenter', highlight, { signal });
          marker.addEventListener('focus', highlight, { signal });
          marker.addEventListener('pointerleave', clear, { signal });
          marker.addEventListener('blur', clear, { signal });
        });
      }
      async select(mode) {
        if (mode === this.dataset.mode || this.loading) return;
        const photo = this.photos.find(item => item.dataset.roomScene === mode);
        const img = photo?.querySelector('img');
        if (!img) return;
        this.loading = true;
        this.buttons.forEach(button => { button.disabled = true; });
        const error = this.querySelector('[data-room-error]');
        try {
          await img.decode();
          if (!this.isConnected) return;
          this.dataset.mode = mode;
          this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.roomMode === mode)));
          this.photos.forEach(item => item.setAttribute('aria-hidden', String(item !== photo)));
          this.markers.hidden = mode === 'before';
          if (error) error.hidden = true;
        } catch {
          if (error) error.hidden = false;
        } finally {
          this.loading = false;
          this.buttons.forEach(button => { button.disabled = false; });
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b100-study-scene"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-study-scene')) {
    customElements.define('b100-study-scene', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.choices = [...this.querySelectorAll('[data-scene-select]')];
        this.panels = [...this.querySelectorAll('[data-scene-panel]')];
        if (!this.panels.length) return;
        this.querySelector('.b100-study__hotspots').hidden = false;
        this.choices.forEach(choice => choice.addEventListener('click', event => {
          event.preventDefault();
          this.select(Number(choice.dataset.sceneSelect));
        }, { signal }));
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, { signal });
        this.select(0);
      }
      select(index) {
        this.panels.forEach((panel, current) => { panel.hidden = current !== index; });
        this.choices.forEach(choice => {
          const selected = Number(choice.dataset.sceneSelect) === index;
          choice.setAttribute(choice.tagName === 'BUTTON' ? 'aria-pressed' : 'aria-current', String(selected));
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b100-visual-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-category-browser')) {
    customElements.define('b100-category-browser', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const list = this.querySelector('[data-category-list]');
        const controls = this.querySelector('[data-category-controls]');
        const previous = this.querySelector('[data-category-previous]');
        const next = this.querySelector('[data-category-next]');
        const update = () => {
          const end = list.scrollWidth - list.clientWidth;
          controls.hidden = end <= 2;
          previous.disabled = list.scrollLeft <= 2;
          next.disabled = list.scrollLeft >= end - 2;
        };
        const move = direction => list.scrollBy({ left: direction * list.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        list.addEventListener('scroll', update, { passive: true, signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(list);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flipbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b100-catalogue')) {
    customElements.define('b100-catalogue', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.pages = [...this.querySelectorAll('[data-catalogue-page]')];
        if (!this.pages.length) return;
        this.canvas = this.querySelector('[data-catalogue-canvas]');
        this.dialog = this.querySelector('dialog');
        this.readerScroll = this.querySelector('.b100-reader__scroll');
        this.readerPages = this.querySelector('.b100-reader__pages');
        this.index = 0;
        this.readerIndex = 0;
        this.zoom = 1;
        this.mql = matchMedia('(min-width: 900px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.perPage = this.mql.matches ? 2 : 1;
        this.dataset.ready = '';
        this.querySelectorAll('[data-enhanced]').forEach(element => { element.hidden = false; });
        this.querySelectorAll('[data-catalogue-prev]').forEach(button => button.addEventListener('click', () => this.turn(-1), { signal }));
        this.querySelectorAll('[data-catalogue-next]').forEach(button => button.addEventListener('click', () => this.turn(1), { signal }));
        this.querySelectorAll('[data-catalogue-thumb]').forEach(button => button.addEventListener('click', () => this.goTo(Number(button.dataset.catalogueThumb)), { signal }));
        this.querySelectorAll('[data-reader-open]').forEach(button => button.addEventListener('click', () => this.openReader(this.index, button.dataset.readerOpen === 'zoom'), { signal }));
        this.pages.forEach((page, index) => page.querySelector('[data-page-open]').addEventListener('click', event => { event.preventDefault(); if (!this.swiped) this.openReader(index, true); }, { signal }));
        this.canvas.addEventListener('keydown', event => {
          if (event.target.closest('a, button, select')) return;
          if (event.key === 'ArrowRight') { event.preventDefault(); this.turn(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.turn(-1); }
          if (event.key === 'Home') { event.preventDefault(); this.goTo(0); }
          if (event.key === 'End') { event.preventDefault(); this.goTo(this.pages.length - 1); }
        }, { signal });
        this.canvas.style.touchAction = 'pan-y pinch-zoom';
        this.canvas.addEventListener('pointerdown', event => { this.swiped = false; this.start = { x: event.clientX, y: event.clientY }; }, { signal });
        this.canvas.addEventListener('pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) { this.swiped = true; this.turn(dx < 0 ? 1 : -1); }
        }, { signal });
        this.canvas.addEventListener('pointercancel', () => { this.start = null; }, { signal });
        this.canvas.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.mql.addEventListener('change', () => { this.cancelTurn(); this.perPage = this.mql.matches ? 2 : 1; this.index = Math.floor(this.index / this.perPage) * this.perPage; this.render(); if (this.dialog.open) this.renderReader(); }, { signal });
        this.querySelector('[data-reader-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.querySelector('[data-reader-prev]').addEventListener('click', () => this.readerStep(-1), { signal });
        this.querySelector('[data-reader-next]').addEventListener('click', () => this.readerStep(1), { signal });
        this.querySelector('[data-reader-select]').addEventListener('change', event => { this.readerIndex = Number(event.target.value); this.renderReader(); }, { signal });
        this.querySelector('[data-reader-in]').addEventListener('click', () => this.setZoom(this.zoom + .5), { signal });
        this.querySelector('[data-reader-out]').addEventListener('click', () => this.setZoom(this.zoom - .5), { signal });
        this.dialog.addEventListener('close', () => {
          this.goTo(this.readerIndex, false);
          this.readerPages.replaceChildren();
          const target = this.returnFocus?.getClientRects().length ? this.returnFocus : this.canvas;
          target.focus({ preventScroll: true });
        }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.target.closest('select') || this.zoom > 1) return;
          if (event.key === 'ArrowRight') { event.preventDefault(); this.readerStep(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.readerStep(-1); }
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => { if (this.dialog.open) this.sizeReader(); });
        this.resizeObserver.observe(this.readerScroll);
        this.visibilityObserver = new IntersectionObserver(entries => { this.dataset.inView = String(entries[0].isIntersecting); });
        this.visibilityObserver.observe(this.canvas);
        const cover = this.pages[0].querySelector('img');
        const syncRatio = () => { if (cover.naturalWidth) { this.ratio = cover.naturalWidth / cover.naturalHeight; this.style.setProperty('--page-ratio', this.ratio); if (this.dialog.open) this.sizeReader(); } };
        cover.addEventListener('load', syncRatio, { signal }); syncRatio();
        document.addEventListener('shopify:block:select', event => { const index = this.pages.findIndex(page => page.dataset.blockId === event.detail?.blockId); if (index >= 0) this.goTo(index, false); }, { signal });
        this.render();
      }
      label(index, count = this.perPage) {
        const last = Math.min(index + count, this.pages.length);
        const pages = last > index + 1 ? `${index + 1}–${last}` : String(index + 1);
        return this.dataset.counterTemplate.replace('[pages]', pages).replace('[total]', this.pages.length);
      }
      showPages(indices) {
        this.pages.forEach((page, index) => { const slot = indices.indexOf(index); page.hidden = slot < 0; page.style.gridColumn = slot < 0 ? '' : String(slot + 1); });
      }
      render() {
        this.dataset.spread = String(this.perPage === 2);
        this.showPages(Array.from({ length: this.perPage }, (_, offset) => this.index + offset));
        this.querySelectorAll('[data-catalogue-counter]').forEach(counter => { counter.textContent = this.label(this.index); });
        this.querySelectorAll('[data-catalogue-prev]').forEach(button => { button.disabled = this.index === 0; });
        this.querySelectorAll('[data-catalogue-next]').forEach(button => { button.disabled = this.index + this.perPage >= this.pages.length; });
        this.querySelectorAll('[data-catalogue-thumb]').forEach(button => { const index = Number(button.dataset.catalogueThumb); button.setAttribute('aria-current', String(index >= this.index && index < this.index + this.perPage)); });
        for (let index = this.index; index < Math.min(this.pages.length, this.index + this.perPage + 2); index++) this.pages[index].querySelector('img').loading = 'eager';
      }
      turn(direction) { this.goTo(this.index + direction * this.perPage); }
      goTo(index, animate = true) {
        if (this.animation) return;
        const next = Math.max(0, Math.min(Math.floor(index / this.perPage) * this.perPage, Math.floor((this.pages.length - 1) / this.perPage) * this.perPage));
        if (next === this.index) return;
        const old = this.index, forward = next > old;
        this.index = next;
        if (!animate || this.motion.matches || Math.abs(next - old) !== this.perPage) { this.render(); return; }
        const leaf = document.createElement('div'); leaf.className = 'b100-catalogue__leaf'; leaf.setAttribute('aria-hidden', 'true');
        const makeFace = index => { const face = document.createElement('div'); face.className = 'b100-catalogue__leaf-face'; const source = this.pages[index]?.querySelector('img'); if (source) { const image = source.cloneNode(); image.alt = ''; image.loading = 'eager'; face.append(image); } return face; };
        if (this.perPage === 2) {
          this.showPages(forward ? [old, next + 1] : [next, old + 1]);
          leaf.style.left = forward ? '50%' : '0';
          leaf.append(makeFace(forward ? old + 1 : old), makeFace(forward ? next : next + 1));
        } else {
          this.showPages([next]); leaf.style.width = '100%'; leaf.style.left = '0'; leaf.append(makeFace(old));
        }
        leaf.style.transformOrigin = forward ? 'left center' : 'right center';
        this.canvas.append(leaf); this.leaf = leaf;
        const angle = (forward ? -1 : 1) * (this.perPage === 2 ? 180 : 105);
        // Animating opacity on the spread would flatten its two 3D faces.
        const keyframes = this.perPage === 2
          ? [{ transform: 'rotateY(0deg)' }, { transform: `rotateY(${angle}deg)` }]
          : [{ transform: 'rotateY(0deg)', opacity: 1 }, { transform: `rotateY(${angle}deg)`, opacity: 0 }];
        this.animation = leaf.animate(keyframes, { duration: Number(this.dataset.duration) || 600, easing: 'cubic-bezier(.25,.55,.25,1)', fill: 'forwards' });
        this.animation.finished.then(() => { this.cancelTurn(); this.render(); }).catch(() => {});
      }
      cancelTurn() { this.animation?.cancel(); this.animation = null; this.leaf?.remove(); this.leaf = null; }
      openReader(index, zoomed) {
        this.returnFocus = document.activeElement;
        this.cancelTurn(); this.render();
        this.readerIndex = index; this.zoom = zoomed ? 1.5 : 1; this.readerSingle = zoomed;
        this.dialog.showModal(); this.renderReader(); this.querySelector('[data-reader-close]').focus();
      }
      readerStep(direction) { this.readerIndex = Math.max(0, Math.min(this.pages.length - 1, this.readerIndex + direction * (this.readerSingle ? 1 : this.perPage))); this.renderReader(); }
      renderReader() {
        const count = this.readerSingle ? 1 : this.perPage;
        this.readerPages.replaceChildren();
        for (let index = this.readerIndex; index < Math.min(this.pages.length, this.readerIndex + count); index++) {
          const source = this.pages[index].querySelector('img'), image = new Image(); image.src = source.dataset.full || source.currentSrc || source.src; image.alt = source.alt; this.readerPages.append(image);
        }
        this.querySelector('[data-reader-counter]').textContent = this.label(this.readerIndex, count);
        this.querySelector('[data-reader-select]').value = String(this.readerIndex);
        this.querySelector('[data-reader-prev]').disabled = this.readerIndex === 0;
        this.querySelector('[data-reader-next]').disabled = this.readerIndex + count >= this.pages.length;
        this.querySelector('[data-reader-original]').href = this.pages[this.readerIndex].querySelector('[data-page-open]').href;
        this.readerScroll.scrollTo(0, 0); this.sizeReader();
      }
      sizeReader() {
        const count = this.readerPages.children.length || 1;
        const ratio = this.ratio || .71945;
        const fit = Math.min((this.readerScroll.clientWidth - 40) / count, (this.readerScroll.clientHeight - 40) * ratio);
        this.readerPages.style.setProperty('--reader-page-width', `${Math.max(100, fit) * this.zoom}px`);
        this.querySelector('[data-reader-scale]').textContent = `${Math.round(this.zoom * 100)}%`;
        this.querySelector('[data-reader-out]').disabled = this.zoom <= 1;
        this.querySelector('[data-reader-in]').disabled = this.zoom >= 3;
      }
      setZoom(zoom) { this.zoom = Math.max(1, Math.min(3, zoom)); this.sizeReader(); }
      disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); this.visibilityObserver?.disconnect(); this.cancelTurn(); this.dialog?.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
